import { createContext, useContext } from 'react';
import type { SampleSectionState } from './useSampleSectionState';

/**
 * Контекст раздела выборок. Состояние раздела нужно и секции списка, и её строке управления,
 * а между ними стоят раскладки страницы диалогов — прокидывать его пропсами через них нельзя.
 */
const SampleSectionContext = createContext<SampleSectionState | null>(null);

export const SampleSectionProviderContext = SampleSectionContext.Provider;

/** Состояние раздела выборок; вне раздела обращение к нему — ошибка сборки страницы */
export const useSampleSection = (): SampleSectionState => {
  const value = useContext(SampleSectionContext);
  if (!value) throw new Error('useSampleSection must be used inside the samples section');
  return value;
};
